import React, { useEffect } from "react";

import "./style.css";
import Home from "./components/home";
import Navbar from "./components/navbar";
import About from "./components/about";
import Service from "./components/services";
import Background from "./components/background";
import Footer from "./components/footer";
import Contact from "./components/contact";

import { createRoot } from "react-dom/client";
import { ToastContainer } from "react-toastify";
import http from "./services/http";
import config from "./config/api.json";

import "./style.css";
import "react-toastify/dist/ReactToastify.css";

function App() {
  useEffect(() => {
    // Initialize app access key
    http.setAppAccess(config.appAccessKey);
  }, []);

  return (
    <div className="App">
      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Navbar />
      <Home />
      <About />
      <Service />
      <Background />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
